import { RazorButton } from "../../../components/razor-reuse";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import NoContentPage from "../../../layout/dashboard/no-content/NoContentPage";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import "../../../styles/dashboard/setting/SettingLayout.css";
import { useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { systemRoles } from "../../../utils/roles";

interface myComponentProps {
  children?: React.ReactNode;
  title?: string;
  btnLabel?: string;
  onBtnClick?: () => void;
  hideBtn?: boolean;
  hideBtnIcon?: boolean;
  btnLoading?: boolean;
  pageLoading?: boolean;
  btnDisable?: boolean;
  back?: boolean;
  onBack?: () => void;
}

const SettingLayout = ({
  children,
  title,
  btnLabel,
  btnLoading,
  hideBtn,
  onBtnClick,
  pageLoading,
  btnDisable,
  hideBtnIcon,
  back,
  onBack,
}: myComponentProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const navList = [
    {
      name: "Profile",
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_PROFILE,
      hide: false,
    },
    {
      name: "Account",
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_ACCOUNT,
      hide: false,
    },
    {
      name: "Notification",
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_NOTIFICATION,
      hide: false,
    },
    // { name: "Announcement", link: ALL_ROUTES?.DASHBOARD_SETTINGS_ANNOUNCEMENT },
    {
      name: "Exchange  Rate",
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE,
      hide: !user?.permissions?.includes(systemRoles[26]),
    },
    {
      name: "Approval Settings",
      link: ALL_ROUTES?.DASHBOARD_SETTINGS_APPROVAL,
      hide: !user?.permissions?.includes("view_approval_setting"),
    },
    // { name: "Manage Features", link: ALL_ROUTES?.DASHBOARD_SETTINGS_MANAGE_FEATURE },
  ];

  return (
    <>
      <DashboardLayoutMain back={back} onBack={onBack} title="Settings">
        <div className="settings-layout-index-wrapper-general-box">
          {/* left wrap start */}
          <div className="left-side-wrap">
            <div className="nav-list-box">
              {navList?.map((chi, idx) => {
                if (chi.hide) return null;
                return (
                  <div
                    key={idx}
                    className={`nav-item ${
                      location?.pathname?.includes(chi?.link)
                        ? `nav-item-active`
                        : ``
                    }`}
                    onClick={() => {
                      if (chi?.link) {
                        navigate(chi?.link);
                      }
                    }}
                  >
                    <p className="name">{chi?.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {/* left wrap end */}
          {/* right wrap start */}
          <div className="right-side-wrap">
            {/* header btn wrap start */}
            <div className="header-btn-wrap">
              <p className="title-settings">{title || ""}</p>
              {/* btn box start */}
              {!hideBtn && (
                <div className="btn-setting-box-wrap">
                  <RazorButton
                    onClick={() => {
                      onBtnClick && onBtnClick();
                    }}
                    loading={btnLoading}
                    color="black-light"
                    className="btn"
                    disabled={btnDisable}
                  >
                    {!hideBtnIcon && (
                      <figure className="img-box">{ALL_ICONS?.plus}</figure>
                    )}
                    <p className="text">{btnLabel}</p>
                  </RazorButton>
                </div>
              )}
              {/* btn box end */}
            </div>
            {/* header btn wrap end */}
            {/* body start */}
            <div className="body-content-wrap">
              {" "}
              {pageLoading ? (
                <>
                  <NoContentPage loading={true} />
                </>
              ) : (
                <>{children}</>
              )}{" "}
            </div>
            {/* body end */}
          </div>
          {/* right wrap end */}
        </div>
      </DashboardLayoutMain>
    </>
  );
};

export default SettingLayout;
